import { z } from 'zod'

// Handle type enum (API uses lowercase for all operations)
export const HandleType = z.enum(['person', 'org'])
export type HandleType = z.infer<typeof HandleType>

// Handle type for create requests (same as HandleType - API expects lowercase)
export const HandleCreateType = z.enum(['person', 'org'])
export type HandleCreateType = z.infer<typeof HandleCreateType>

// Full handle object returned from API
export const Handle = z.object({
  id: z.number().int(),
  external_id: z.number().int(),
  account_data: z.boolean(),
  type: HandleType,
  name: z.string().optional(),
  org: z.string().optional(),
  street: z.string(),
  city: z.string(),
  postcode: z.string(),
  state: z.string(),
  country: z.string().max(2),
  phone: z.string(),
  fax: z.string().optional(),
  email: z.string().email(),
  // NIS2 verification fields
  email_verified: z.boolean().optional(),
  email_verified_at: z.string().nullable().optional(),
  phone_verified: z.boolean().optional(),
  phone_verified_at: z.string().nullable().optional(),
  needs_revalidation: z.boolean().optional(),
  // NIS2 deadline for imported handles (90 days after import)
  verification_deadline: z.string().datetime().nullable().optional(),
  imported_at: z.string().datetime().nullable().optional()
})

export type Handle = z.infer<typeof Handle>

// Request body for creating a new handle
export const HandleCreateRequest = z.object({
  type: HandleCreateType,
  name: z.string().optional(),
  org: z.string().optional(),
  street: z.string(),
  city: z.string(),
  postcode: z.string(),
  state: z.string(),
  country: z.string().max(2),
  phone: z.string(),
  fax: z.string().optional(),
  email: z.string().email()
})

export type HandleCreateRequest = z.infer<typeof HandleCreateRequest>

// Request body for updating a handle
export const HandleUpdateRequest = z.object({
  name: z.string().optional(),
  org: z.string().optional(),
  street: z.string(),
  city: z.string(),
  postcode: z.string(),
  state: z.string(),
  country: z.string().max(2),
  phone: z.string(),
  fax: z.string().optional(),
  email: z.string().email()
})

export type HandleUpdateRequest = z.infer<typeof HandleUpdateRequest>
